import { takeEvery, all, call, put, select } from 'redux-saga/effects';
import { getAllGenerator, findGenerator } from 'helpers/resourceSagas';
import * as api from './api';
import * as types from './types';
import * as actions from './actions';
import { setUpcomingPlan } from 'subscriptions/bypassed/actions';
import { getBypassedPlan } from 'reducers';

export const fetchAll = getAllGenerator({
  resourceType: 'bypassedPlans',
  endpoint: api.fetchAll,
  endpointArgs: (payload) => [payload.subId],
  transformResponse: (resp) => resp.data.results,
});

export const find = findGenerator({
  resourceType: 'bypassedPlans',
  endpoint: api.find,
});

export function* findUpcoming({ payload: { subId } }) {
  try {
    const resp = yield call(api.upcomingCycles, subId);
    if (resp.data.results.length === 0) { throw new Error('Cycle not found') }
    const cycle = resp.data.results[0];
    const planId = cycle.plan;
    yield call(find, actions.find(planId));
    const plan = yield select(getBypassedPlan, planId);
    yield put(setUpcomingPlan(subId, plan));
  }
  catch (err) {
    yield put(actions.findUpcomingFailed(subId, err));
  }
}

export function* watchFetchAll() {
  yield takeEvery(types.FETCH_ALL, fetchAll);
}

export function* watchFind() {
  yield takeEvery(types.FIND, find);
}

export function* watchFindUpcoming() {
  yield takeEvery(types.FIND_UPCOMING, findUpcoming);
}

export function* watchBypassedPlans() {
  yield all([
    call(watchFetchAll),
    call(watchFind),
    call(watchFindUpcoming),
  ]);
}
